module.exports = __webpack_public_path__ + "fonts/HelveticaNowDisplay-Regular.4d6f00ca4f7a13d697a4d99223979c46.woff2";